<template>
  <div class="upload-tool">
    <Upload
      :action="action"
      name="file"
      :format="imgFormat"
      :data="extraParams"
      :show-upload-list="false"
      :headers="headers"
      :max-size="5120"
      :before-upload="beforeUpload"
      :on-progress="handleStart"
      :on-format-error="handleFormatError"
      :on-exceeded-size="handleImgMaxSize"
      :on-success="handleSuccess"
      :on-error="handleError"
    >
      <Icon type="ios-image-outline"></Icon>
    </Upload>
    
  </div>
</template>

<script>
import StoreUtils from "@/utils/StoreUtils";
import conf from "@/views/im/conf";

export default {
  name: "upload-tool",
  data() {
    return {
      imgFormat: ["jpg", "jpeg", "png", "gif"],
      fileFormat: [
        "doc",
        "docx",
        "jpg",
        "jpeg",
        "png",
        "gif",
        "xls",
        "xlsx",
        "pdf",
        "gif",
        "exe",
        "msi",
        "swf",
        "sql",
        "apk",
        "psd"
      ],
      extraParams: {
      },
      tokenFile: {
        access_token: StoreUtils.getAccessToken(),
        type: "file"
      },
      action: conf.getHostUrl()+"/shopee/message/uploadImage",
      headers: {
        token: StoreUtils.getToken()
      }
    };
  },
  methods: {
    beforeUpload() {
      this.extraParams = {store_id: this.$store.state.shopee.currentStore.id};
      return new Promise(resolve => {
        this.$nextTick(function() {
          resolve(true);
        });
      });
    },

    // 错误提示
    openMessage(error) {
      this.$Message.error(error);
    },

    handleStart() {
      this.$Loading.start();
    },
    handleFormatError(file) {
      this.$Message.warning("文件 " + file.name + " 格式不正确。");
    },
    handleImgMaxSize(file) {
      this.$Message.warning("图片 " + file.name + " 太大，不能超过 512K！");
    },
    handleFileMaxSize(file) {
      this.$Message.warning("文件 " + file.name + " 太大，不能超过 10M！");
    },
    handleSuccess(res, file) {
      let self = this;
        console.log(res);
      if (res.code === 1) {
        console.log(file);
        //给父类传值
        self.$emit("uploadback", res.data);

        this.$Loading.finish();
      } else {
        this.$Message.error("文件上传错误，请重试");
      }
    },
    handleError: function() {
      this.$Loading.finish();
      this.$Message.error("上传错误！");
    }
  }
};
</script>

<style scoped>
.upload-tool {
  display: inline-block;
}
</style>
